import { Component, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from '@app/state';
import { BaseComponent } from '@components/base.component';
import { GroupService } from '@app/services/group.service';
import { SidebarService } from '@services/sidebar.service';

@Component({
  selector: 'app-group-view-users',
  templateUrl: './group-view-users.component.html',
  styleUrls: [],
  providers: [SidebarService]
})
@Injectable()
export class GroupViewUsersComponent extends BaseComponent {

  public group: {
    name: string,
    uuid: string,
    created_by_user: any,
    created_user: any,
    created_at: string,
    member_count: number,
    members_with_attributes: any
  };
  public dataLoaded = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public groupService: GroupService,
    public sidebarService: SidebarService,
    public state: State,
    public router: Router
  ) {
    super();
    this.setObjects({
      route: activatedRoute,
      sidebarService,
      state,
      router,
      modelService: groupService
    });
    this.setPageVars({
      sidebar: ''
    });
    this.modelServiceGetOne(this.routeParams['id'], 'group').then(() => {
      this.dataLoaded = true;
    });
  }

  public closeSlideout() {
    this.state.message({ slideoutHide: true });
  }
}
